import styled, { keyframes } from 'styled-components'

const blur = keyframes`
  from {
    backdrop-filter: blur(0);
    background: rgba(0, 0, 0, 0);
  } to {
    backdrop-filter: blur(3px);
    background: rgba(0, 0, 0, 0.2);
  }
`

const fadeIn = keyframes`
  from {
    opacity: 0;
  } to {
    opacity: 1;
  }
`

const grow = keyframes`
  from {
    transform: scale(0.8);
  } to {
    transform: scale(1);
  }
`

export const Grid = styled.div`
  position: fixed;
  inset: 0;
  z-index: 99999999;

  padding: 1rem;

  display: flex;
  justify-content: center;
  align-items: center;

  &.show {
    animation: ${blur} 0.5s both linear;

    .modal-container {
      animation: ${fadeIn} 0.3s 0.2s both linear, ${grow} 0.15s 0.2s both linear;
    }
  }
`

export const Container = styled.div`
  width: 100%;
  max-width: 900px;

  background: var(--modal-background);
  border: var(--modal-border);
  border-radius: 4px;

  box-shadow: var(--modal-shadow);

  padding: 2rem;

  position: relative;

  .modal-close-button {
    position: absolute;
    top: 0;
    right: 0;

    width: 1.5rem;
    height: 1.5rem;

    margin: 0.5rem;

    background: transparent;
    border: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 1.25rem;
  }
`

export const Section = styled.section.attrs({ className: 'modal-section' })`
  max-height: 80vh;
  overflow-y: auto;
`
